import { request } from "../../../services/api"
import type { BaseApiResponse } from "../../../types/api.ts"
import type { SyncOverviewResponse, SyncStatusResponse } from "../types.ts"

const PATHS = {
  proposalSyncStatus: (id: string) =>
    `/proposal/v2/proposals/${id}/sync-status/`,
  contractSyncStatus: (id: string) =>
    `/proposal/v2/contracts/${id}/sync-status/`,
  proposalSyncToLead: (id: string) =>
    `/proposal/v2/proposals/${id}/sync-to-lead/`,
  contractSyncToLead: (id: string) =>
    `/proposal/v2/contracts/${id}/sync-to-lead/`,
  contractSyncToProposal: (id: string) =>
    `/proposal/v2/contracts/${id}/sync-to-proposal/`,
  leadSyncOverview: (id: string) => `/crm/leads/${id}/sync-overview/`,
  leadApprovalSyncPreview: (id: string) =>
    `/project-management/lead-approval/${id}/sync-preview/`
}

export const getProposalSyncStatus = (proposalId: string) =>
  request.api.get<SyncStatusResponse, BaseApiResponse<unknown>>(
    PATHS.proposalSyncStatus(proposalId)
  )

export const getContractSyncStatus = (contractId: string) =>
  request.api.get<SyncStatusResponse, BaseApiResponse<unknown>>(
    PATHS.contractSyncStatus(contractId)
  )

export const syncProposalToLead = (proposalId: string, fields: string[]) =>
  request.api.post<BaseApiResponse<unknown>, BaseApiResponse<unknown>>(
    PATHS.proposalSyncToLead(proposalId),
    { fields }
  )

export const syncContractToLead = (contractId: string, fields: string[]) =>
  request.api.post<BaseApiResponse<unknown>, BaseApiResponse<unknown>>(
    PATHS.contractSyncToLead(contractId),
    { fields }
  )

/**
 * New this pass — every prior pass explicitly forbade writing into a
 * Proposal/Contract; this is the one deliberate, opt-in exception (Contract
 * → Proposal, fired only from `ContractGenerateConfirmModal`'s "Update
 * Proposal" checkbox). Same request/response shape as `syncContractToLead`.
 */
export const syncContractToProposal = (contractId: string, fields: string[]) =>
  request.api.post<BaseApiResponse<unknown>, BaseApiResponse<unknown>>(
    PATHS.contractSyncToProposal(contractId),
    { fields }
  )

export const getLeadSyncOverview = (leadId: string) =>
  request.api.get<SyncOverviewResponse, BaseApiResponse<unknown>>(
    PATHS.leadSyncOverview(leadId)
  )

export const getLeadApprovalSyncPreview = (leadApprovalId: string) =>
  request.api.get<SyncOverviewResponse, BaseApiResponse<unknown>>(
    PATHS.leadApprovalSyncPreview(leadApprovalId)
  )
